import React from 'react';
import FlowBuilder from '../flow/FlowBuilder';

export default function AutomationFlowModal({
  template,
  isNew = false,
  settings,
  onClose,
  onSave,
  onPreview,
  onSettingsChange,
  saving,
  error,
  onClearError,
}) {
  return (
    <FlowBuilder
      template={template}
      settings={settings}
      isNew={isNew}
      onClose={onClose}
      onSave={onSave}
      onPreview={onPreview}
      onSettingsChange={onSettingsChange}
      saving={saving}
      saveError={error}
      onClearSaveError={onClearError}
    />
  );
}
